import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { User } from '../../../api/models/user-model';
import { FormGroup, Validators, FormBuilder, FormControl, AbstractControl } from '@angular/forms';
import { UserService } from '../../../api/services/user.service';
import { ToastrService } from 'ngx-toastr';
import { DeleteModalComponent } from '../../delete-modal/delete-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/filter';
import { Team } from '../../../api/models/team';
import { PreferencesService } from '../../../api/services/preferences.service';
import { MarketService } from '../../../api/services/market.service';
import { Organization } from '../../../api/models/organization';
import { AuthService } from '../../../api/services/auth.service';
import { Market } from '../../../api/models/market-model';
import { Observable } from 'rxjs/Observable';
import { RoleRequest } from '../../../api/models/role-assignment-map';


@Component({
  selector: 'app-user-edit',
  templateUrl: './user-edit.component.html',
  styleUrls: ['./user-edit.component.scss']
})
export class UserEditComponent implements OnInit {

  userForm: FormGroup;

  @Input() user: User;

  @Output() leaveEdit = new EventEmitter<any>();

  username: string;

  userExists: Boolean = true;

  editing = true;

  newUser = false;

  loadingSearch = false;

  canEditFields = false;

  loading = false;

  teams: Team[];

  organizations: Organization[];

  isOrgAdmin = false;

  allowedMarkets = [];

  markets: Market[] = [];

  specialSelected: string;

  invalidUserName: Boolean = false;

  isTesscoAdmin: boolean = false;
  roleRequest: RoleRequest;
  
  constructor(
    private userService: UserService,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private authService: AuthService,
    private preferencesService: PreferencesService,
    private marketService: MarketService
  ) {
  }

  findUser(userId: string) {
    if (userId && userId.length >= 3) {
      this.invalidUserName = false;
      this.loadingSearch = true;
      this.authService.isUsernameInUsed(userId)
        .subscribe(exist => {
          this.loadingSearch = false;
          this.userExists = exist;
          this.userExists && this.onUserExists();
        });
    } else {
      this.invalidUserName = true;
    }
  }
  
  searchTeams() {
    this.authService.getOrganizationTeams(this.userForm.controls['Organization ID'].value).subscribe(orgTeams => {
      this.teams = orgTeams;
    });
  }

  searchMarkets() {
    this.specialSelected = null;
    this.allowedMarkets = [];
    this.markets = [];
    this.preferencesService.getPreferences('CUSTOMER', this.userForm.controls['Organization ID'].value).subscribe(prefs => {
      this.specialSelected = prefs['special-fields'].Value;
    });
    this.marketService.getMarkets(this.userForm.controls['Organization ID'].value)
    .subscribe(markets => {
      this.markets = markets;
      if (this.user['User ID'] && this.user.markets) {
        this.user.markets.forEach(marketId => {
          this.allowedMarkets.push({ id: marketId, readonly: this.isTesscoAdmin ? false : true, name: this.markets.find(market => market.id === marketId).name });
        });
      }
    });
  }

  saveUser() {
    Object.keys(this.userForm.value).forEach(k => {
      if (this.userForm.value[k] && typeof this.userForm.value[k] == 'string') {
        this.userForm.value[k] = this.userForm.value[k].trim();
        this.userForm.controls[k].setValue(this.userForm.value[k].trim());
        this.userForm.controls[k].updateValueAndValidity();
      }
    });
    if (this.userForm.valid) {
      this.loadingSearch = true;
      Object.assign(this.user, this.userForm.value);
      if (this.user.isAdmin && this.specialSelected !== 'ATC') {
        this.user.markets = this.allowedMarkets.map(entity => entity.id);
      }
      this.userService.saveUser(this.user)
        .subscribe(c => {
          if (this.authService.getUserId() === c['User ID']) {
            this.userService.updateCurrentUserMarketIds(c['User ID']);
          }
          this.user['User ID'] = c['User ID'];
          c.isAdmin = this.user.isAdmin;
          this.username = this.userForm.get('Username') ? this.userForm.get('Username').value : this.username;
          this.setUserPreference();
          this.canEditFields = true;
          this.userForm.controls.isAdmin.disable();
          this.userForm.controls['Organization ID'].disable();
          this.onUserSubscription(c)
          this.onUpdateSuccess();
          this.loadingSearch = false;
        }, error => {
          const err = error.error;
          this.onUpdateError(err.message);
          this.loadingSearch = false;
        });
    }
  }

  private setUserPreference() {
    this.userService.findOrganizationById(this.user['Organization ID']).subscribe(org => {
      this.preferencesService.setPreference('USER', this.user['User ID'], 'company', { Value: org.Name }).subscribe();
    });
  }

  private onUserSubscription(user: User) {
    this.userForm = this.formBuilder.group({
      'First Name': [user['First Name'], [Validators.required]],
      'Last Name': [user['Last Name'], [Validators.required]],
      'Email Address': [user['Email Address'], [Validators.required, Validators.email]],
      'Organization ID': [user['Organization ID'], [Validators.required]],
      'SMS Phone Number': [user['SMS Phone Number']],
      'BP Contact Number': [user['BP Contact Number']],
      isAdmin: [user.isAdmin],
      'Approved Dollar Figure': [user['Approved Dollar Figure']],
      'Team ID': [user['Team ID']],
      'Team Notes': [user['Team Notes']]
    });

    if (this.user['User ID']) {
      this.userForm.controls['Organization ID'].disable();
      //this.userForm.controls['Team ID'].disable();
      this.userForm.controls.isAdmin.disable();
      this.searchMarkets();
    }

    if(!this.canEditFields){
      this.userForm.controls['BP Contact Number'].disable();
    }

    !this.editing && this.userForm.addControl('Username', new FormControl(this.username,  [Validators.required]));
  }

  private onUpdateSuccess() {
    this.toastr.success('User saved!!!', 'Succcess!', {
      timeOut: 3000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onResetSuccess() {
    this.toastr.success('Mail sent successfully!!!', 'Succcess!', {
      timeOut: 2000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onUserExists() {
    this.toastr.error('Username already taken', 'Error!', {
      timeOut: 5000,
      positionClass: 'toast-bottom-right'
    });
  }

  private onUpdateError(error: string) {
    this.toastr.error(error, 'Error!', {
      timeOut: 5000,
      positionClass: 'toast-bottom-right'
    });
  }

  resetPassword() {
    this.authService.getUserNameByUserId(this.user['User ID'])
      .subscribe(username => {
        this.authService.resetPassword(username).subscribe(() => this.onResetSuccess());
      });
  }

  deleteUser() {
    const modalRef = this.modalService.open(DeleteModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false
    });
    modalRef.componentInstance.bodyMsg = `Are you sure you want to delete the User <strong>${this.user['First Name']} ${this.user['Last Name']}</strong> ?`;
    modalRef.componentInstance.fn = () => {
      this.userService.removeUser(this.user['User ID']).subscribe(() => {
        modalRef.close();
        this.leaveEdit.emit();
      });
    };
  }

  goBack() {
    this.leaveEdit.emit();
  }

  ngOnInit() {
    this.loading = true;
    this.roleRequest = new RoleRequest('ADMIN_TESSCO', null);
    this.roleRequest.setRoleAndContextMap('ADMIN_CLIENT', null);
    this.authService.getUserRoles(this.roleRequest).subscribe(roles => {
      this.isTesscoAdmin = roles.getRoleMap('ADMIN_TESSCO');
	  });

    this.userService.getOrganizations().subscribe(organizations => {
      this.organizations = organizations;
    });

    this.userService.findUserById(this.authService.getUserId())
      .switchMap(user => this.authService.getUserRolesInContext(`ORGANIZATION~${user['Organization ID']}`))
      .subscribe(roles => {
        this.canEditFields = roles.some(r => roles.includes('ADMIN_TESSCO') || roles.includes('ADMIN_CLIENT'));
        if (this.user['User ID']) {
          this.authService.getUserNameByUserId(this.user['User ID']).subscribe(username => {
            this.username = username;
          });
    
          let isUserAnAdmin;
          this.authService.isUserAnAdmin(this.user['User ID']).subscribe(result => {
            isUserAnAdmin = result;
            if(isUserAnAdmin!=null && isUserAnAdmin == 'true'){
              this.user.isAdmin = true;
            }else{
              this.user.isAdmin = false;
            }
            this.onUserSubscription.call(this, this.user);
          });
    
          this.loading = false;
          this.authService.getOrganizationTeams(this.user['Organization ID'])
            .subscribe((teams: Team[]) => {
            this.teams = teams;
          });
         
        } else {
          this.editing = false;
          this.loading = false;
          this.newUser = true;
          this.onUserSubscription.call(this, this.user);
        }  
      }); 
  }

  autocompleteAllowedMarkets = (text: string) => {
    return Observable.of(this.markets.filter(market => market.name.toLocaleLowerCase().indexOf(text.toLocaleLowerCase()) >= 0 
            && !this.allowedMarkets.map(entity => entity.id).includes(market.id))
      .map(market => {
        return { name: market.name, id: market.id };
      }));
  }
}


// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/management/user-edit/user-edit.component.ts